
import { Vue, Component, Prop } from 'vue-property-decorator';
import ServiceItem from '@/features/shipment/components/checkout/ServiceItem.vue';
import Details from '@/features/shipment/components/checkout/Details.vue';
import TotalCost from '@/features/shipment/components/checkout/TotalCost.vue';
import { getPrice } from '@/features/common/helpers';
import { patchPreferences } from '@/features/settings/services/preferences.services';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { AvailableService } from '@/features/shipment/types';

@Component({
  components: {
    ServiceItem,
    Details,
    TotalCost,
  },
})
export default class PaymentInfo extends Vue {
  @Prop({ required: true }) showDetails!: boolean;

  private getPrice = getPrice;

  get isInternationalShipment(): boolean {
    return this.$store.getters.getIsInternational;
  }

  get selectedService(): AvailableService {
    return this.$store.state.shipment.selectedService;
  }

  get totalCost(): number {
    return this.selectedService.total;
  }

  get currencyCode(): string {
    return this.selectedService.currencyCode;
  }

  get totalPackagesCount(): number {
    const summary = this.$store.getters.getPackageSummary;
    if (!summary) return 0;
    return summary.length;
  }

  get userPreferencesId(): number {
    return this.$store.state.userPreferences.id;
  }

  get isAlwaysShow(): boolean {
    const userPref = this.$store.getters.getUserPreferences;
    if (!userPref) return false;
    return userPref.shippingSettings.showSummaryPage;
  }

  set isAlwaysShow(val: boolean) {
    this.updateUserPref(val);
  }

  private updateUserPref(value: boolean) {
    this.$store.commit('patchUserPreferences', {
      key: 'shippingSettings/showSummaryPage',
      value,
    });

    patchPreferences(this.userPreferencesId, [
      {
        path: 'shippingSettings/showSummaryPage',
        op: 'replace',
        value,
      },
    ]);
  }

  private openDetails = () => eventBus.$emit(eventNames.OPEN_CHECKOUT_DETAILS);

  private hideDetails = () => eventBus.$emit(eventNames.HIDE_CHECKOUT_DETAILS);
}
